/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/** @example {"id":"7b96cfbf-7abb-4a8a-9709-675d9ba03214","tripId":"cd61bf83-b43d-4e19-9d55-187e9b1103c8","transport":{"id":1,"mode":"Plane"},"origin":{"id":"1140ade6-3282-4bb6-9505-895ce476709d","segmentId":"7b96cfbf-7abb-4a8a-9709-675d9ba03214","city":{"id":"595bfe3a-a37b-4fe2-bee4-d3c1c31d96b8","name":"Boston","country":{"code":"US","name":"United States of America","highRisk":false},"state":{"id":"MA","name":"Massachusetts","countryCode":"US"}},"locationDate":"2021-07-12","comment":"This is the beginning of my trip"},"destination":{"id":"aa0c7ce2-4377-4499-b4f4-1df73a60f090","city":{"id":"4dde747d-6a7a-4702-be5d-c32798c8735a","name":"Johannesburg","country":{"code":"ZA","name":"South Africa","highRisk":true}},"locationDate":"2021-07-13"},"comment":null,"createdBy":"joejj","createdOn":"2021-01-01","updatedBy":"joejj","updatedOn":"2021-02-20"} */
export interface Segment {
  id?: string;
  tripId: string;
  highRiskRequirementsId?: string | null;
  highRiskRequirementsStatus?:
    | "required"
    | "info"
    | "pending"
    | "approved"
    | "rejected"
    | null;
  transport: Transport;
  origin: Location;
  destination: Location;
  comment?: string;
  adminManagedKey?: string;
  finalDestination?: boolean;
  createdBy?: string;
  createdOn?: string;
  updatedBy?: string;
  updatedOn?: string;
}

export interface ExportItem {
  /** The name of the exported file */
  name?: string;
  /** The URL to download the exported file */
  url?: string;
  /** The MIME type of the exported file */
  mime?: string;
}

export interface AdminProgramsOverview {
  fromRecord?: number;
  toRecord?: number;
  totalRecords?: number;
  totalRecordsIncluded?: boolean;
  canNext?: boolean;
  canPrevious?: boolean;
  list?: Program[];
}

export interface AdminProgramStats {
  totalPrograms?: number;
  totalTravelers?: number;
  totalRegisteredTravelers?: number;
}

export interface AdminTripsOverview {
  fromRecord?: number;
  toRecord?: number;
  totalRecords?: number;
  totalRecordsIncluded?: boolean;
  canNext?: boolean;
  canPrevious?: boolean;
  list?: Trip[];
}

export interface AdminTripStats {
  totalProgramTrips?: number;
  totalBusinessTrips?: number;
  totalPersonalTrips?: number;
  totalTrips?: number;
  totalTravelers?: number;
}

export interface AdminTrips {
  tripLeg?: AirSegment | Segment;
  travelers?: string[];
}

export interface Accommodation {
  recommendSafeStay: boolean;
  establishments: Establishment[];
}

export interface Activity {
  name?: string;
  includes?: string;
}

export interface AirlineList {
  airlines?: Airline[];
}

/** @example {"name":"Delta Air Lines, Inc.","code":"DL"} */
export interface Airline {
  name?: string;
  code?: string;
}

export interface AirportList {
  airports?: Airport[];
}

export interface Airport {
  cityCode?: string;
  cityName?: string;
  stateProv?: string;
  countryCode?: string;
  timeZoneCode?: string;
  stv?: string;
  airportCode?: string;
  airportName?: string;
  numericCode?: string;
  locationType?: number;
  iata?: string;
}

export interface AirSegments {
  segments?: AirSegment[];
}

export type AirSegment = Segment & {
  id?: string;
  airlineCode: string;
  airlineName?: string;
  flightNumber: string;
  segmentId?: string;
};

export interface Authorization {
  authorizationID?: string;
  category?: string;
  doFunction?: string;
  effectiveDate?: string;
  expirationDate?: string;
  functionName?: string;
  grantAuth?: string;
  isActive?: string;
  principal?: string;
  qualifierName?: string;
  qualifierCode?: string;
  qualifierType?: string;
  modifiedBy?: string;
  modifiedDate?: string;
}

export interface CityList {
  cities?: City[];
}

/** @example {"id":"595bfe3a-a37b-4fe2-bee4-d3c1c31d96b8","name":"Miami","country":{"code":"US","name":"United States","highRisk":false},"state":{"id":"FL","name":"Florida","countryCode":"US"},"locationLong":24.939876,"locationLat":60.169091} */
export interface City {
  id?: string;
  name: string;
  country: Country;
  state?: State;
  locationLong?: string | null;
  locationLat?: string | null;
}

export interface CitySearchList {
  cities?: CitySearch[];
}

export interface CitySearch {
  id?: string;
  name?: string;
  country?: Country;
  state?: State;
  cityCode?: string;
  locationType?: string;
  locationLong?: number | null;
  locationLat?: number | null;
}

export interface Communication {
  contacts: HighRiskContact[];
  periodicCheckIn: boolean;
  checkInDescription?: string;
  socialMedia: SocialMedia;
  livedWorkedStudiedAtLocation: boolean;
  livedWorkedStudiedAtLocationDescription?: string;
  livedWorkedStudiedAtSimilarLocation: boolean;
  livedWorkedStudiedAtSimilarLocationDescription?: string;
}

export interface ContactList {
  contacts?: (TravelerContact | Contact)[];
}

export interface ProgramContact {
  id?: string;
  mitId?: string;
  tripId?: string;
  programId?: string;
  contactType: "self" | "emergency";
}

export type TravelerContact = ProgramContact & {
  phoneNumber: string;
  contactAddress: string;
};

export type Contact = ProgramContact & {
  contactName: string;
  phoneNumber: string;
  contactRelation: string;
  emailAddress: string;
  contactAddress?: string;
};

export interface Countries {
  countries?: Country[];
}

/** @example {"code":"ZA","name":"South Africa","highRisk":true,"description":"Too many new Covid variants being produced by Africa"} */
export interface Country {
  code: string;
  name?: string;
  highRisk?: boolean;
  description?: string | null;
  updatedOn?: string | null;
}

export interface Departments {
  departments?: Department[];
}

/** @example {"id":"D_BIOLOGY","name":"Department of Biology"} */
export interface Department {
  id: string;
  name: string;
}

export interface Establishment {
  name: string;
  address: string;
  phoneNumber: string;
  emailAddress?: string;
  websiteURL?: string;
  websiteDisplayURL?: string;
  methodOfLocating?: string;
  geoLocation: GeoLocation;
  placeId?: string;
  city: string;
  country: Country;
}

export interface GeoLocation {
  locationType?: string;
  latitude: string;
  longitude: string;
}

export interface HighRiskContact {
  name: string;
  address: string;
  phoneNumber: string;
  emailAddress?: string;
}

export interface HighRiskPrograms {
  programs?: HighRiskProgram[];
}

export interface HighRiskTravelers {
  travelers?: HighRiskTraveler[];
}

export type HighRiskTraveler = Traveler & {
  highRiskTripId?: string;
  highRiskRequirementsId?: string;
  endorsementId?: string;
  endorsementStatus?: EndorsementStatus;
  tripStatus?: "approved" | "updates" | "unapproved" | "rejected";
  departureDate?: string;
  arrivalDate?: string;
  updatedOn?: string;
  programProgressStatus?: string;
};

export interface Endorsement {
  tripId: string;
}

export type EndorsementStatus = EndorsementStatusItem[];

export interface EndorsementStatusItem {
  endorser:
    | "Faculty or Instructional Leader"
    | "Dean(s) of School"
    | "Head(s) of Department";
  status: "uncompleted" | "completed" | "declined";
  declinedInfo?: {
    declinedReason: string;
    declinerName: string;
    declinerEmail: string;
    declinerRoleName: string;
    declinedDateTime: string;
  };
}

export interface Envelope {
  envelopeId: string;
}

export interface HighRiskProgramTrips {
  trips?: HighRiskProgramTrip[];
}

export interface HighRiskProgramTrip {
  id?: string;
  tripId?: string;
  programId?: string;
  status?: string;
  reasonRejected?: string;
  firstName?: string;
  lastName?: string;
  mitId?: string;
  krbName?: string;
  departureDate?: string;
  returnDate?: string;
  legs?: HighRiskTripLeg[];
}

export interface HighRiskTrips {
  trips?: HighRiskTrip[];
}

export interface HighRiskTrip {
  programId: string;
  tripName: string;
  country: Country;
  tripYear: string;
  department: Department;
  tripLeader: string;
  tripLeaderKrb: string;
  adminOfficer?: string;
  purposeOfTrip: string;
  reasonForTrip: string;
  courseDescriptionOrSummaryKey?: string;
  courseDescriptionOrSummaryURL?: string | null;
  collaborateWithLocalAlumniOrContacts: boolean;
  activities?: Activity[];
  humanResearch: boolean;
  collectPII: boolean;
  collaborateOrSupportByOrgs: boolean;
  localSupportOrgs?: LocalSupportOrganization[];
  logisticalSupportFromLocalSupportOrgs: boolean;
  localLodgingSupport?: string;
  localTransportSupport?: string;
  localCommunicationsSupport?: string;
  localEmergencySupport?: string;
  moreThanTwentyPerFlight: boolean;
}

export interface HighRiskTripSummaries {
  tripSummaries?: (HighRiskTripSummary | HighRiskTraveler)[];
}

export interface HighRiskTripSummary {
  id?: string;
  tripName?: string;
  tripYear?: string;
  countryName?: string;
  travelerCount?: number;
}

export interface HighRiskEvents {
  events?: HighRiskEvent[];
}

export interface HighRiskEvent {
  id?: string;
  eventName: string;
  country: Country;
  eventYear: string;
}

export interface HighRiskProgramRequirements {
  tripId: string;
  programId: string;
  programName: string;
  purpose: Purpose;
  accommodation: Accommodation;
  transportation: Transportation;
  communication: Communication;
  moreDetailsRequest?: string;
  docuSignDate?: string;
  endorsementId?: string;
  endorsementStatus?: EndorsementStatus;
  /** @default true */
  draft: boolean;
  status?: "required" | "info" | "pending" | "approved" | "rejected";
  active: boolean;
  createdOn?: string;
  updatedOn?: string;
}

export interface HighRiskBusinessRequirements {
  tripId: string;
  purpose: BusinessPurpose;
  accommodation: Accommodation;
  transportation: Transportation;
  communication: Communication;
  localSupport: LocalBusinessSupport;
  moreDetailsRequest?: string;
  docuSignDate?: string;
  endorsementId?: string;
  endorsementStatus?: EndorsementStatus;
  /** @default true */
  draft: boolean;
  status?: "required" | "info" | "pending" | "approved" | "rejected";
  active: boolean;
  createdOn?: string;
  updatedOn?: string;
}

export interface HighRiskTripLeg {
  transportModeId?: string;
  origin?: HighRiskLocation;
  destination?: HighRiskLocation;
  explanation?: string;
}

export type HighRiskProgram = HighRiskTravel & {
  programName?: string;
  startDate?: string;
  endDate?: string;
  department?: string;
  cityName?: string;
  countryName?: string;
  description?: string;
  krbName?: string;
};

export interface HighRiskLocation {
  locationDate?: string;
  transportHub?: string;
  cityName?: string;
  countryName?: string;
}

export interface HighRiskTravel {
  id?: string;
  tripId?: string;
  programId?: string;
  status: "pending" | "approved" | "rejected" | "information";
  explanations: HighRiskTravelExplanation[];
  reasonRejected?: string;
  createdBy?: string;
  createdOn?: string;
  approvedBy?: string;
  approvedOn?: string;
  rejectedBy?: string;
  rejectedOn?: string;
}

export interface HighRiskTravelExplanation {
  highRiskTravelId?: string;
  countryCode: string;
  description: string;
}

export interface HotelSegments {
  segments?: HotelSegment[];
}

export type HotelSegment = Segment & {
  id?: string;
  hotelName: string;
  hotelAddress?: string;
};

export type HotelSegmentUpdate = Segment &
  HotelSegment & {
    id?: string;
    hotelName: string;
    hotelAddress?: string;
    segmentId?: string;
  };

export interface LocalBusinessSupport {
  collaborateOrSupportByOrgs: boolean;
  localCommunicationsSupport: string;
  localEmergencySupport: string;
  localLodgingSupport: string;
  localSupportOrgs?: LocalSupportOrganization[];
  localTransportSupport: string;
  logisticalSupportFromLocalSupportOrgs: boolean;
}

export interface LocalSupportOrganization {
  id?: string;
  name?: string;
  director?: string;
  emailAddress?: string;
  phoneNumber?: string;
}

export interface Locations {
  locations?: Location[];
}

/** @example {"id":"1140ade6-3282-4bb6-9505-895ce476709d","city":{"id":"595bfe3a-a37b-4fe2-bee4-d3c1c31d96b8","name":"Boston","country":{"code":"US","name":"United States of America","highRisk":false}},"transportHub":"EK Bus Station","locationDate":"2021-07-12","locationCode":"ZVJ","locationType":4,"createdBy":"joejj","createdOn":"2021-06-15","updatedBy":null,"updatedOn":null} */
export interface Location {
  id?: string;
  city: City;
  /** General entry for airport, train station, car, bus station and other. */
  transportHub?: string;
  locationDate: string;
  locationCode?: string;
  locationType?: string;
  createdBy?: string;
  createdOn?: string;
  updatedBy?: string;
  updatedOn?: string;
}

export interface Person {
  krbName?: string;
  personType?: string;
}

export interface Programs {
  programs?: Program[];
}

/** @example {"id":"b89ddf85-9c20-44cd-8fef-7c7e75a62d7e","name":"ELO Funding Eligibility Workshop","startDate":"2021-07-12","endDate":"2021-08-15","deadlineDate":"2021-07-02","city":{"id":"595bfe3a-a37b-4fe2-bee4-d3c1c31d96b8","name":"Pretoria","country":{"code":"ZA","name":"South Africa","highRisk":true}},"description":"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).","department":"D_BIOLOGY","reviewStatus":"pending","createdBy":"joejj","createdOn":"2021-01-01","updatedBy":"joejj","updatedOn":"2021-02-20","cancelledBy":"null,","cancelledOn":null} */
export interface Program {
  id?: string;
  name: string;
  startDate: string;
  endDate: string;
  deadlineDate?: string;
  city: City;
  description: string;
  department: string;
  reviewStatus?: string | null;
  highRiskId?: string | null;
  highRisk?: boolean;
  travelers?: Traveler[];
  createdBy?: string;
  createdOn?: string;
  updatedBy?: string;
  updatedOn?: string;
  cancelledBy?: string;
  cancelledOn?: string;
}

/** Not used by front-end */
export interface ProgramInvitee {
  programId?: string;
  travelerId?: string;
  invitedBy?: string;
  inviteDate?: string;
}

/** @example {"numInvitees":51,"numReady":32} */
export interface ProgramInviteeStatus {
  numInvitees?: number;
  numReady?: number;
}

/** @example {"tripId":"cd61bf83-b43d-4e19-9d55-187e9b1103c8","acknowledgement":true,"training":true,"vaccination":true,"tripLeg":false,"travelerInfo":false,"emergencyInfo":false,"localInfo":false,"status":"busy","updatedOn":"2021-06-23"} */
export interface Progress {
  tripId: string;
  acknowledgement?: boolean;
  training?: boolean;
  vaccination?: boolean;
  tripLeg?: boolean;
  travelerInfo?: boolean;
  emergencyInfo?: boolean;
  status?: "none" | "busy" | "done";
  updatedOn?: string;
}

export interface Purpose {
  signedContractOrReceivedGrant: boolean;
  visasOrWorkPermitsObtained?: boolean | null;
  crossBorderTransportOf?: string;
  traveledToLocationBefore: boolean;
  previousDateAtLocation?: string;
  policyWaiverApproved?: boolean;
}

export interface BusinessPurpose {
  activities: Activity[];
  collaborateWithLocalAlumniOrContacts: boolean | null;
  collectPII: boolean | null;
  crossBorderTransportOf?: string;
  humanResearch: boolean | null;
  policyWaiverApproved: boolean | null;
  previousDateAtLocation?: string;
  purposeOfTrip: string;
  reasonForTrip: string;
  signedContractOrReceivedGrant: boolean;
  traveledToLocationBefore?: boolean;
  visasOrWorkPermitsObtained?: boolean | null;
  adminOfficer: string;
  departmentId: string;
  departmentName: string;
  tripLeader: string;
  tripLeaderKrb: string;
}

export interface QueryParams {
  q: string;
  n?: number;
  p?: number;
  countryCode?: string;
}

export type StationQueryParams = UtilRequiredKeys<QueryParams, "q"> & {
  stationType: string;
};

export interface RailSegments {
  setments?: RailSegment[];
}

export type RailSegment = Segment & {
  id?: string;
  vendorCode: string;
  vendorName?: string;
};

export type RailSegmentUpdate = Segment & {
  id?: string;
  vendorCode: string;
  vendorName?: string;
  segmentId?: string;
};

export interface Railways {
  providers?: Railway[];
}

/** @example {"name":"Amtrak","code":"2V"} */
export interface Railway {
  name?: string;
  code?: string;
}

export interface RequirementsComments {
  comments?: RequirementsComment[];
}

export interface RequirementsComment {
  comment?: string;
  commentDate?: string | null;
}

export interface SocialMedia {
  facebook?: string;
  instagram?: string;
  twitter?: string;
  linkedIn?: string;
}

export interface StateList {
  states?: State[];
}

export interface State {
  id?: string;
  name?: string;
  countryCode?: string;
}

export interface StationList {
  stations?: Station[];
}

export interface Station {
  cityCode?: string;
  cityName?: string;
  stateProv?: string;
  countryCode?: string;
  timeZoneCode?: string;
  stv?: string;
  stationCode?: string;
  stationName?: string;
  numericCode?: string;
  locationType?: string;
}

export interface Role {
  admin?: boolean;
  superAdmin?: boolean;
  manageHighRisk?: boolean;
}

export interface Segments {
  segments?: Segment[];
}

export interface Step {
  step?: string;
  skippable?: boolean;
  order?: number;
}

export interface UploadUrl {
  /** Identifier of the existing document */
  key?: string;
  /**
   * Document mime type
   * @example "application/pdf"
   */
  documentType: string;
  url?: string;
}

export interface Training {
  completed?: boolean;
}

export interface Transportation {
  airportTransferMethod: string;
  arriveAfterDark: boolean;
  dailyCommuteMethod: string;
  riskMitigation: string;
}

export interface Travelers {
  travelers?: Traveler[];
}

/** @example {"id":"ae07eb19-e250-4a74-ba67-dcbf4360dda1","mitId":987654321,"krbName":"joejj","firstName":"Joe","lastName":"Jay-Jay","middleName":"Borris","department":"D_BIOLOGY","email":"joejj@example.com"} */
export interface Traveler {
  id?: string;
  mitId?: string;
  krbName?: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  department?: string;
  email?: string;
}

export interface TripDetails {
  details?: TripDetail[];
}

export interface TripDetail {
  invitedBy?: string | null;
  invitedOn?: string | null;
  programName?: string | null;
  trip?: Trip;
  traveler?: Traveler;
  progress?: Progress;
  travelerContact?: (ProgramContact & TravelerContact) | null;
  emergencyContact?: (ProgramContact & Contact) | null;
}

export interface Trips {
  trips?: Trip[];
}

/** @example {"id":"cd61bf83-b43d-4e19-9d55-187e9b1103c8","mitId":987654321,"departureOn":"2021-07-12","returnOn":"2021-08-16","tripType":"program","programId":"7496631b-de47-4bcb-887c-324384eb77fc","programName":"The big Egypt dig","highRiskRequirementsStatus":"pending","moreDetailsRequest":"I will need some more information","segments":[{"id":"7b96cfbf-7abb-4a8a-9709-675d9ba03214","tripId":"cd61bf83-b43d-4e19-9d55-187e9b1103c8","transport":{"id":"plane","mode":"Plane"},"origin":{"id":"1140ade6-3282-4bb6-9505-895ce476709d","city":{"id":"595bfe3a-a37b-4fe2-bee4-d3c1c31d96b8","name":"Boston","country":{"code":"US","name":"United States of America","highRisk":false}},"locationDate":"2021-07-12"},"destination":{"id":"aa0c7ce2-4377-4499-b4f4-1df73a60f090","city":{"id":"4dde747d-6a7a-4702-be5d-c32798c8735a","name":"Johannesburg","country":{"code":"ZA","name":"South Africa","highRisk":true}},"locationDate":"2021-07-13"},"comment":"This is the beginning of my trip","flightNumber":"A143","airlineCode":"AAL"}],"reviewStatus":"approved","createdBy":"joejj","createdOn":"2021-01-01","updatedBy":"joejj","updatedOn":"2021-02-20","cancelledBy":"null,","cancelledOn":null} */
export interface Trip {
  id?: string;
  mitId?: string;
  departureOn?: string;
  returnOn?: string;
  tripType: "program" | "business" | "personal";
  programId?: string | null;
  highRiskRequirementsStatus?:
    | "required"
    | "info"
    | "pending"
    | "approved"
    | "rejected"
    | "normal";
  moreDetailsRequest?: string | null;
  programName?: string | null;
  segments?: (AirSegment | HotelSegment | RailSegment | Segment)[];
  reviewStatus?: string | null;
  createdBy?: string;
  createdOn?: string;
  updatedBy?: string;
  updatedOn?: string;
  cancelledBy?: string;
  cancelledOn?: string;
  isFederal?: boolean;
  isFederalApproved?: boolean;
  federalProject?: string | null;
  projectDescription?: string | null;
  federalSupervisorKrbName?: string | null;
  affiliation?: string | null;
  traveler?: Traveler | null;
  isSoloTripAcknowledged?: boolean;
}

export interface Transports {
  transports?: Transport[];
}

/** @example {"id":"plane","mode":"Plane","seq":1} */
export interface Transport {
  id?: string;
  /** @default "none" */
  mode?: string;
  seq?: number;
}

export interface Url {
  url?: string;
}

export interface Flight {
  airlineName?: string;
  airlineCode?: string;
  arrivalCountryCode?: string;
  arrivalMunicipalityName?: string;
  arrivalAirportName?: string;
  arrivalScheduledTime?: string;
  arrivalAirportCode?: string;
  departureCountryCode?: string;
  departureMunicipalityName?: string;
  departureAirportName?: string;
  departureScheduledTime?: string;
  departureAirportCode?: string;
  number?: string;
  status?: string;
}

export interface LoanerDevice {
  displayName: string;
  value: string;
  sysId: string;
}

export interface LoanerRequest {
  requestedFor: string;
  returnDate: string;
  description: string;
  phoneNumber: string;
  devices: string[];
  costObject: string;
  address: string;
  city: string;
  state?: string;
  zip?: string;
  country?: string;
  acknowledgement: boolean;
}

export interface LoanerRequestId {
  ticketNumber: string;
  ticketRedirectUrl: string;
}

/** @example {"code":"ZA","name":"English"} */
export interface Language {
  code: string;
  name: string;
}

export interface TravelProfile {
  id?: string;
  mitId?: string;
  citizenships?: Citizenship[];
  passports?: Passport[];
  visas?: Visa[];
  languages?: string[];
  active?: boolean;
}

export interface Citizenship {
  profileId?: string;
  countryCode: string;
  countryName?: string;
}

export interface Passport {
  id?: string;
  mitId?: string;
  passportNumber?: string;
  issueDate?: string;
  expiryDate?: string;
  nationalityCountryCode?: string;
  profileId?: string;
  imageUrl?: string;
  active?: boolean;
  s3Key?: string;
}

export interface Visa {
  id?: string;
  mitId?: string;
  issueDate?: string;
  expiryDate?: string;
  countryCode?: string;
  profileId?: string;
  imageUrl?: string;
  active?: boolean;
  s3Key?: string;
}

export interface ApiHealthPingResponse {
  service: {
    name: string;
    version: string;
  };
  deployment: {
    region: string;
  };
  stage: {
    name: string;
  };
}

export interface ApiStatusResponse {
  service: {
    name: string;
    version: string;
  };
  deployment: {
    region: string;
  };
  stage: {
    name: string;
  };
  status: string;
  dependencies: {
    name: string;
    status: string;
    message?: string;
  }[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://global.api.mit.edu/travel/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Travel API
 * @version 3.0.3
 * @baseUrl https://global.api.mit.edu/travel/v1
 */
export class TravelApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  airlines = {
    /**
     * @description Get a list of IATA Airlines
     *
     * @tags User
     * @name AirlinesList
     * @summary Get a list of Airlines
     * @request GET:/airlines
     * @secure
     */
    airlinesList: (
      query: {
        /** Query string to search for */
        q: string;
        /** The number of results to return; defaults to 20 */
        n?: number;
        /** The page number of results to return; defaults to 1 */
        p?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AirlineList, any>({
        path: `/airlines`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  airports = {
    /**
     * @description Get a list of IATA Airports
     *
     * @tags User
     * @name AirportsList
     * @summary Get a list of Airports
     * @request GET:/airports
     * @secure
     */
    airportsList: (
      query: {
        /**
         * Query string to search for
         * @example "OR Tambo"
         */
        q: string;
        /**
         * The number of results to return; defaults to 20
         * @example 10
         */
        n?: number;
        /**
         * The page number of results to return; defaults to 1
         * @example 1
         */
        p?: number;
        /**
         * The country code used to limit the search. If not provided, defaults to 'US'
         * @example "ZA"
         */
        countryCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AirportList, any>({
        path: `/airports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of IATA Airports
     *
     * @tags User
     * @name AeroboxList
     * @summary Get a list of Airports
     * @request GET:/airports/aerobox
     * @secure
     */
    aeroboxList: (
      query: {
        /**
         * Query string to search for
         * @example "OR Tambo"
         */
        search: string;
        /**
         * The number of results to return; defaults to 20
         * @example 10
         */
        maxResults?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Airport[], any>({
        path: `/airports/aerobox`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  cities = {
    /**
     * No description
     *
     * @tags User
     * @name CitiesList
     * @summary Get a list of Cities
     * @request GET:/cities
     * @secure
     */
    citiesList: (
      query: {
        /**
         * Query string to search for
         * @example "Munich"
         */
        q: string;
        /**
         * The number of results per page to return; defaults to 20
         * @example 10
         */
        n?: number;
        /**
         * The page number of results to return; defaults to 1
         * @example 1
         */
        p?: number;
        /**
         * The country code used to limit the search. If not provided, defaults to 'US'
         * @example "DE"
         */
        countryCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CitySearchList, any>({
        path: `/cities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contacts = {
    /**
     * @description A list of emergency or traveler contact details for a trip, program or user (if no trip and program id is provided).
     *
     * @tags User
     * @name ContactsList
     * @summary Get list of contacts.
     * @request GET:/contacts
     * @secure
     */
    contactsList: (
      query: {
        /** Return emergency or traveler contacts details. */
        contactType: "emergency" | "self";
        /** The trip to get contacts for. */
        tripId?: string;
        /** The program to get contacts for. */
        programId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactList, any>({
        path: `/contacts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add emergency or traveler contact details to a program or a trip.
     *
     * @tags User
     * @name ContactsCreate
     * @summary Add emergency or traveler contact details.
     * @request POST:/contacts
     * @secure
     */
    contactsCreate: (
      data: TravelerContact | Contact,
      params: RequestParams = {},
    ) =>
      this.request<TravelerContact | Contact, any>({
        path: `/contacts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update emergency or traveler contact details.
     *
     * @tags User
     * @name ContactsUpdate
     * @summary Update emergency or traveler contact details.
     * @request PUT:/contacts
     * @secure
     */
    contactsUpdate: (
      data: TravelerContact | Contact,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contacts`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  countries = {
    /**
     * @description A list of countries is returned. The list can be filtered by providing either a *high_risk* or *country_code* parameter. If both are provided, the *high_risk* parameter will take presedence if it is true.
     *
     * @tags User
     * @name CountriesList
     * @summary Get list of countries.
     * @request GET:/countries
     * @secure
     */
    countriesList: (
      query?: {
        /** Return only high risk countries if true; if it is false or absent, all countries will be returned */
        highRisk?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Countries, any>({
        path: `/countries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update the high-risk status of a country
     *
     * @tags Admin
     * @name CountriesUpdate
     * @summary Update a country's high-risk status
     * @request PUT:/countries
     * @secure
     */
    countriesUpdate: (data: Country, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/countries`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CountriesDetail
     * @summary Return a specific country identified by the country code.
     * @request GET:/countries/{countryCode}
     * @secure
     */
    countriesDetail: (countryCode: string, params: RequestParams = {}) =>
      this.request<
        {
          countries?: Country[];
        },
        any
      >({
        path: `/countries/${countryCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  languages = {
    /**
     * @description A list of languages is returned.
     *
     * @tags User
     * @name LanguagesList
     * @summary Get list of languages.
     * @request GET:/languages
     * @secure
     */
    languagesList: (params: RequestParams = {}) =>
      this.request<Language[], any>({
        path: `/languages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  departments = {
    /**
     * No description
     *
     * @tags Admin
     * @name DepartmentsList
     * @summary Get a list of departments
     * @request GET:/departments
     * @secure
     */
    departmentsList: (
      query?: {
        /** Query string to search for */
        all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Departments, any>({
        path: `/departments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  highRisk = {
    /**
     * No description
     *
     * @tags User, Admin
     * @name HighRiskList
     * @summary Get high-risk travel
     * @request GET:/high-risk
     * @secure
     */
    highRiskList: (
      query: {
        /** Return high-risk programs if true; else return high-risk trips */
        programs: boolean;
        /** Filter on a specific status */
        status: "pending" | "approved" | "rejected" | "information";
      },
      params: RequestParams = {},
    ) =>
      this.request<HighRiskProgramTrips | HighRiskPrograms, void>({
        path: `/high-risk`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, Admin
     * @name HighRiskCreate
     * @summary Add a high-risk program or trip entry
     * @request POST:/high-risk
     * @secure
     */
    highRiskCreate: (data: HighRiskTravel, params: RequestParams = {}) =>
      this.request<HighRiskTravel, void>({
        path: `/high-risk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, Admin
     * @name HighRiskUpdate
     * @summary Update a high-risk program or trip entry
     * @request PUT:/high-risk
     * @secure
     */
    highRiskUpdate: (data: HighRiskTravel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/high-risk`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name EndorsementsCreate
     * @summary Send for endorsement
     * @request POST:/high-risk/endorsements
     * @secure
     */
    endorsementsCreate: (data: Endorsement, params: RequestParams = {}) =>
      this.request<Envelope, any>({
        path: `/high-risk/endorsements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name EventsList
     * @summary Get high-risk events
     * @request GET:/high-risk/events
     * @secure
     */
    eventsList: (
      query?: {
        /** The country code the high-risk events are taking place in */
        countryCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HighRiskEvents, any>({
        path: `/high-risk/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, Admin
     * @name RequirementsList
     * @summary Get specific high-risk requirements
     * @request GET:/high-risk/requirements
     * @secure
     */
    requirementsList: (
      query: {
        /** The ID of the trip */
        tripId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        HighRiskProgramRequirements | HighRiskBusinessRequirements,
        void
      >({
        path: `/high-risk/requirements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RequirementsCreate
     * @summary Add high-risk requirements
     * @request POST:/high-risk/requirements
     * @secure
     */
    requirementsCreate: (
      data: HighRiskProgramRequirements | HighRiskBusinessRequirements,
      params: RequestParams = {},
    ) =>
      this.request<
        HighRiskProgramRequirements | HighRiskBusinessRequirements,
        any
      >({
        path: `/high-risk/requirements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RequirementsUpdate
     * @summary Update high-risk requirements
     * @request PUT:/high-risk/requirements
     * @secure
     */
    requirementsUpdate: (
      data: HighRiskProgramRequirements | HighRiskBusinessRequirements,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/high-risk/requirements`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User, Admin
     * @name RequirementsDetail
     * @summary Get specific high-risk requirements
     * @request GET:/high-risk/requirements/{id}
     * @secure
     */
    requirementsDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        HighRiskProgramRequirements | HighRiskBusinessRequirements,
        void
      >({
        path: `/high-risk/requirements/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RequirementsDelete
     * @summary Remove high-risk requirements
     * @request DELETE:/high-risk/requirements/{id}
     * @secure
     */
    requirementsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/high-risk/requirements/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RequirementsApproveUpdate
     * @summary Approve requirements
     * @request PUT:/high-risk/requirements/{id}/approve
     * @secure
     */
    requirementsApproveUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/high-risk/requirements/${id}/approve`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RequirementsRejectUpdate
     * @summary Reject requirements
     * @request PUT:/high-risk/requirements/{id}/reject
     * @secure
     */
    requirementsRejectUpdate: (
      id: string,
      data: RequirementsComment,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/high-risk/requirements/${id}/reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RequirementsUpdatesList
     * @summary Request updates to requirements
     * @request GET:/high-risk/requirements/{id}/updates
     * @secure
     */
    requirementsUpdatesList: (id: string, params: RequestParams = {}) =>
      this.request<RequirementsComments, void>({
        path: `/high-risk/requirements/${id}/updates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RequirementsUpdatesUpdate
     * @summary Request updates to requirements
     * @request PUT:/high-risk/requirements/{id}/updates
     * @secure
     */
    requirementsUpdatesUpdate: (
      id: string,
      data: RequirementsComment,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/high-risk/requirements/${id}/updates`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name HighRiskDetail
     * @summary Get a high-risk travel entry
     * @request GET:/high-risk/{id}
     * @secure
     */
    highRiskDetail: (id: string, params: RequestParams = {}) =>
      this.request<HighRiskTravel, void>({
        path: `/high-risk/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ApproveUpdate
     * @summary Mark a high-risk entry as approved
     * @request PUT:/high-risk/{id}/approve
     * @secure
     */
    approveUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/high-risk/${id}/approve`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * @description Reset the high-risk entry"s status to pending. This is done on, for example, the resubmission of a Program for re-assesment.
     *
     * @tags User, Admin
     * @name PendingUpdate
     * @summary Mark a high-risk entry as pending
     * @request PUT:/high-risk/{id}/pending
     * @secure
     */
    pendingUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/high-risk/${id}/pending`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RejectUpdate
     * @summary Mark a high-risk entry as rejected
     * @request PUT:/high-risk/{id}/reject
     * @secure
     */
    rejectUpdate: (
      id: string,
      data: {
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/high-risk/${id}/reject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name InformationUpdate
     * @summary Mark a high-risk entry as more information required
     * @request PUT:/high-risk/{id}/information
     * @secure
     */
    informationUpdate: (
      id: string,
      data: {
        /** The reason for requiring more information */
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/high-risk/${id}/information`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ProgramsDetail
     * @summary Get a high-risk travel entry for a program
     * @request GET:/high-risk/programs/{id}
     * @secure
     */
    programsDetail: (id: string, params: RequestParams = {}) =>
      this.request<HighRiskTravel, void>({
        path: `/high-risk/programs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TripsList
     * @summary Get high-risk trips
     * @request GET:/high-risk/trips
     * @secure
     */
    tripsList: (
      query?: {
        /** The type of trip (program or solo) */
        tripType?: string;
        /** The status of the trip (current or past) */
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HighRiskTripSummaries, any>({
        path: `/high-risk/trips`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TripsCreate
     * @summary Create a high-risk trip
     * @request POST:/high-risk/trips
     * @secure
     */
    tripsCreate: (data: HighRiskTrip, params: RequestParams = {}) =>
      this.request<HighRiskTrip, any>({
        path: `/high-risk/trips`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TripsUpdate
     * @summary Update a high-risk trip
     * @request PUT:/high-risk/trips
     * @secure
     */
    tripsUpdate: (data: HighRiskTrip, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/high-risk/trips`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, User
     * @name TripsDetail
     * @summary Get a high-risk trip by ID
     * @request GET:/high-risk/trips/{id}
     * @secure
     */
    tripsDetail: (
      id: string,
      query?: {
        /** Trip defined by admin if true; else normal user trip */
        admin?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<HighRiskTrip | HighRiskTravel, void>({
        path: `/high-risk/trips/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TripsDelete
     * @summary Delete a high-risk trip by ID
     * @request DELETE:/high-risk/trips/{id}
     * @secure
     */
    tripsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/high-risk/trips/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TripsUploadUrlCreate
     * @summary Create an upload URL for the course description or research summary document
     * @request POST:/high-risk/trips/upload/url
     * @secure
     */
    tripsUploadUrlCreate: (data: UploadUrl, params: RequestParams = {}) =>
      this.request<UploadUrl, any>({
        path: `/high-risk/trips/upload/url`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TravelersList
     * @summary Retrieve a list of travelers for a high risk trip
     * @request GET:/high-risk/travelers
     * @secure
     */
    travelersList: (
      query: {
        /** Return list of travelers for the high risk trip */
        programId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HighRiskTravelers, void>({
        path: `/high-risk/travelers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  programs = {
    /**
     * No description
     *
     * @tags Admin
     * @name ProgramsList
     * @summary Retrieve a list of Programs
     * @request GET:/programs
     * @secure
     */
    programsList: (
      query?: {
        /** Return only current and future programs if 'current', completed programs if 'past' and high risk programs that haven't been approved if 'rejected'; defaults to 'current' */
        status?: "current" | "past" | "rejected";
      },
      params: RequestParams = {},
    ) =>
      this.request<Programs, void>({
        path: `/programs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ProgramsCreate
     * @summary Add a new Program
     * @request POST:/programs
     * @secure
     */
    programsCreate: (data: Program, params: RequestParams = {}) =>
      this.request<Program, void>({
        path: `/programs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ProgramsUpdate
     * @summary Update a Program
     * @request PUT:/programs
     * @secure
     */
    programsUpdate: (data: Program, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/programs`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, User
     * @name ProgramsDetail
     * @summary Retrieve a Program
     * @request GET:/programs/{id}
     * @secure
     */
    programsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Program, void>({
        path: `/programs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ProgramsDelete
     * @summary Remove a Program
     * @request DELETE:/programs/{id}
     * @secure
     */
    programsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/programs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name StatsList
     * @summary Retrieve Traveler statistics for a Program
     * @request GET:/programs/{id}/stats
     * @secure
     */
    statsList: (id: string, params: RequestParams = {}) =>
      this.request<ProgramInviteeStatus, void>({
        path: `/programs/${id}/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  riskRequirements = {
    /**
     * No description
     *
     * @tags User, Admin
     * @name RiskRequirementsList
     * @summary Get specific high-risk requirements
     * @request GET:/risk-requirements
     * @secure
     */
    riskRequirementsList: (
      query: {
        /** The ID of the trip */
        tripId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        HighRiskProgramRequirements | HighRiskBusinessRequirements,
        void
      >({
        path: `/risk-requirements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RiskRequirementsCreate
     * @summary Add high-risk requirements
     * @request POST:/risk-requirements
     * @secure
     */
    riskRequirementsCreate: (
      data: HighRiskProgramRequirements | HighRiskBusinessRequirements,
      params: RequestParams = {},
    ) =>
      this.request<
        HighRiskProgramRequirements | HighRiskBusinessRequirements,
        any
      >({
        path: `/risk-requirements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RiskRequirementsUpdate
     * @summary Update high-risk requirements
     * @request PUT:/risk-requirements
     * @secure
     */
    riskRequirementsUpdate: (
      data: HighRiskProgramRequirements | HighRiskBusinessRequirements,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/risk-requirements`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  progress = {
    /**
     * No description
     *
     * @tags User
     * @name ProgressList
     * @summary Get Trip progress
     * @request GET:/progress
     * @secure
     */
    progressList: (
      query?: {
        /** Program Id used to retrieve trip progress information */
        programId?: string;
        /** Trip Id used to retrieve trip progress information */
        tripId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Progress, any>({
        path: `/progress`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ProgressUpdate
     * @summary Update Trip progress
     * @request PUT:/progress
     * @secure
     */
    progressUpdate: (data: Progress, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/progress`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  railways = {
    /**
     * No description
     *
     * @tags User
     * @name RailwaysList
     * @summary Retrieve a list of Railways
     * @request GET:/railways
     * @secure
     */
    railwaysList: (params: RequestParams = {}) =>
      this.request<Railways, any>({
        path: `/railways`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  roles = {
    /**
     * No description
     *
     * @tags User
     * @name RolesList
     * @summary Check if this person has admin roles
     * @request GET:/roles
     * @secure
     */
    rolesList: (params: RequestParams = {}) =>
      this.request<Role, any>({
        path: `/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  segments = {
    /**
     * No description
     *
     * @tags User
     * @name SegmentsList
     * @summary Get a list of Segments for the Trip
     * @request GET:/segments
     * @secure
     */
    segmentsList: (
      query: {
        /** The Trip ID */
        tripId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AirSegments | HotelSegments | RailSegments | Segments, void>(
        {
          path: `/segments`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags User
     * @name SegmentsCreate
     * @summary Add a Segment
     * @request POST:/segments
     * @secure
     */
    segmentsCreate: (
      data: AirSegment | HotelSegment | RailSegment | Segment,
      params: RequestParams = {},
    ) =>
      this.request<AirSegment | HotelSegment | RailSegment | Segment, any>({
        path: `/segments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SegmentsUpdate
     * @summary Update a Segment
     * @request PUT:/segments
     * @secure
     */
    segmentsUpdate: (
      data: AirSegment | HotelSegment | RailSegment | Segment,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/segments`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SegmentsDetail
     * @summary Add a specific Segment
     * @request GET:/segments/{id}
     * @secure
     */
    segmentsDetail: (id: string, params: RequestParams = {}) =>
      this.request<AirSegment | HotelSegment | RailSegment | Segment, any>({
        path: `/segments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SegmentsDelete
     * @summary Remove a Segment
     * @request DELETE:/segments/{id}
     * @secure
     */
    segmentsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/segments/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  states = {
    /**
     * No description
     *
     * @tags User
     * @name StatesList
     * @summary Retrieve a list of States for all countries, or for just a country
     * @request GET:/states
     * @secure
     */
    statesList: (
      query?: {
        /** The country code to find State information for */
        countryCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StateList, any>({
        path: `/states`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stations = {
    /**
     * @description Get a list of IATA Stations, either Railway or Bus depending on requested type
     *
     * @tags User
     * @name StationsList
     * @summary Get a list of Stations
     * @request GET:/stations
     * @secure
     */
    stationsList: (
      query: {
        /**
         * Query string to search for
         * @example "Gautrain"
         */
        q: string;
        /**
         * The number of results to return; defaults to 20
         * @example 15
         */
        n?: number;
        /**
         * The page number of results to return; defaults to 1
         * @example 2
         */
        p?: number;
        /**
         * Type of station
         * @example "train"
         */
        stationType: "bus" | "train";
        /**
         * The country code used to limit the search. If not provided, defaults to "US"
         * @example "ZA"
         */
        countryCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StationList, any>({
        path: `/stations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  persons = {
    /**
     * No description
     *
     * @tags User, Admin
     * @name PersonsDetail
     * @summary Get a person using their KRB Name
     * @request GET:/persons/{krbName}
     * @secure
     */
    personsDetail: (krbName: string, params: RequestParams = {}) =>
      this.request<Person, void>({
        path: `/persons/${krbName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  training = {
    /**
     * No description
     *
     * @tags User
     * @name TrainingList
     * @summary Get the status of travel training
     * @request GET:/training
     * @secure
     */
    trainingList: (params: RequestParams = {}) =>
      this.request<Training, any>({
        path: `/training`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  transportModes = {
    /**
     * No description
     *
     * @tags User
     * @name TransportModesList
     * @summary Get a list of transport modes
     * @request GET:/transport-modes
     * @secure
     */
    transportModesList: (params: RequestParams = {}) =>
      this.request<Transports, any>({
        path: `/transport-modes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TransportModesDetail
     * @summary Get a transport mode
     * @request GET:/transport-modes/{id}
     * @secure
     */
    transportModesDetail: (id: string, params: RequestParams = {}) =>
      this.request<Transport, void>({
        path: `/transport-modes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  travelers = {
    /**
     * No description
     *
     * @tags Admin
     * @name TravelersList
     * @summary Retrieve a list of Travelers, or a Traveler via MIT ID
     * @request GET:/travelers
     * @secure
     */
    travelersList: (
      query?: {
        /** Limit Travelers to a specific department */
        department?: string;
        /** The MIT ID of the Traveler to get */
        mitId?: string;
        /** The KRB Name of the Traveler to get */
        krbName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Travelers, any>({
        path: `/travelers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name TravelersDetail
     * @summary Get details for a Traveler
     * @request GET:/travelers/{id}
     * @secure
     */
    travelersDetail: (id: string, params: RequestParams = {}) =>
      this.request<Traveler, any>({
        path: `/travelers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SearchList
     * @summary Retrieve a list of Travelers, via search query
     * @request GET:/travelers/search
     * @secure
     */
    searchList: (
      query: {
        /** The search query to be evaluated */
        searchQuery: string;
        /** Limit Travelers to a specific department. Empty implies all departments included */
        department?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Travelers, any>({
        path: `/travelers/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trips = {
    /**
     * No description
     *
     * @tags User
     * @name TripsList
     * @summary Get a list of trips
     * @request GET:/trips
     * @secure
     */
    tripsList: (
      query?: {
        /** Return only current and future trips if "current", completed trips if "past" and high risk trips that haven"t been approved if "rejected"; defaults to "current" */
        status?: "current" | "past" | "rejected";
      },
      params: RequestParams = {},
    ) =>
      this.request<Trips, any>({
        path: `/trips`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsCreate
     * @summary Add a trip
     * @request POST:/trips
     * @secure
     */
    tripsCreate: (data: Trip, params: RequestParams = {}) =>
      this.request<Trip, any>({
        path: `/trips`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsUpdate
     * @summary Update a trip
     * @request PUT:/trips
     * @secure
     */
    tripsUpdate: (data: Trip, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/trips`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsDetail
     * @summary Get a trip
     * @request GET:/trips/{id}
     * @secure
     */
    tripsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Trip, any>({
        path: `/trips/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsDelete
     * @summary Cancel a trip
     * @request DELETE:/trips/{id}
     * @secure
     */
    tripsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/trips/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  tripDetails = {
    /**
     * No description
     *
     * @tags Admin
     * @name TripDetailsList
     * @summary Get Trip details for a Program, Trip or a Traveler
     * @request GET:/trip-details
     * @secure
     */
    tripDetailsList: (
      query?: {
        /** Id of Program */
        programId?: string;
        /** Id of Trip */
        tripId?: string;
        /** Id of Traveler */
        travelerId?: string;
        /** Return only current and future trips if "current", completed trips if "past" and high risk trips that haven"t been approved if "rejected"; defaults to "current" */
        status?: "current" | "past" | "rejected";
      },
      params: RequestParams = {},
    ) =>
      this.request<TripDetails, any>({
        path: `/trip-details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  flights = {
    /**
     * @description Get a list of Flights from flight api
     *
     * @tags User
     * @name FlightsList
     * @summary Get a list of Flights
     * @request GET:/flights
     * @secure
     */
    flightsList: (
      query: {
        /** Query string to search for */
        flightNumber: string;
        /** The date to search for */
        date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Flight[], any>({
        path: `/flights`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  loanerDevices = {
    /**
     * @description Get a list of loaner devices
     *
     * @tags User
     * @name LoanerDevicesList
     * @summary Get a list of loaner devices
     * @request GET:/loaner-devices
     * @secure
     */
    loanerDevicesList: (params: RequestParams = {}) =>
      this.request<LoanerDevice[], any>({
        path: `/loaner-devices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of loaner requests
     *
     * @tags User
     * @name RequestList
     * @summary Get a list of loaner requests
     * @request GET:/loaner-devices/request
     * @secure
     */
    requestList: (
      query?: {
        /** Query tripId for any loaner requests */
        tripId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LoanerRequestId[], any>({
        path: `/loaner-devices/request`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RequestCreate
     * @summary Request a loaner
     * @request POST:/loaner-devices/request
     * @secure
     */
    requestCreate: (
      query: {
        /** The tripId for the loaner request */
        tripId: string;
      },
      data: LoanerRequest,
      params: RequestParams = {},
    ) =>
      this.request<LoanerRequestId, any>({
        path: `/loaner-devices/request`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
     * @description Get an overview for programs
     *
     * @tags Admin Program Overview
     * @name ProgramsList
     * @request GET:/admin/programs
     * @secure
     */
    programsList: (
      query?: {
        pageNumber?: string;
        pageSize?: string;
        sortField?: string;
        sortOrder?: string;
        searchText?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        departments?: string;
        cities?: string;
        countries?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProgramsOverview, any>({
        path: `/admin/programs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ProgramsDetail
     * @summary Get a program
     * @request GET:/admin/programs/{id}
     * @secure
     */
    programsDetail: (id: string, params: RequestParams = {}) =>
      this.request<TripDetail[], any>({
        path: `/admin/programs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ProgramsDelete
     * @summary Cancel a program
     * @request DELETE:/admin/programs/{id}
     * @secure
     */
    programsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/programs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Notification reminders to travelers in a program
     *
     * @tags Admin
     * @name ProgramsNotificationsCreate
     * @request POST:/admin/programs/{id}/notifications
     * @secure
     */
    programsNotificationsCreate: (
      id: string,
      data: {
        missingPassportMitIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add a list of travelers
     *
     * @tags Admin
     * @name ProgramsTravelersCreate
     * @request POST:/admin/programs/{id}/travelers
     * @secure
     */
    programsTravelersCreate: (
      id: string,
      data: Travelers,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/travelers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Export a program's travelers to excel
     *
     * @tags Admin Program Travelers Export
     * @name ProgramsTravelersExportList
     * @request GET:/admin/programs/{id}/travelers/export
     * @secure
     */
    programsTravelersExportList: (id: string, params: RequestParams = {}) =>
      this.request<ExportItem, any>({
        path: `/admin/programs/${id}/travelers/export`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add a list of trip legs for travelers
     *
     * @tags Admin
     * @name ProgramsTripsCreate
     * @request POST:/admin/programs/{id}/trips
     * @secure
     */
    programsTripsCreate: (
      id: string,
      data: AdminTrips,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/trips`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update a list of trip legs for travelers
     *
     * @tags Admin
     * @name ProgramsTripsUpdate
     * @request PUT:/admin/programs/{id}/trips
     * @secure
     */
    programsTripsUpdate: (
      id: string,
      data: AdminTrips,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/trips`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete a list of trip legs for travelers
     *
     * @tags Admin
     * @name ProgramsTripsDelete
     * @request DELETE:/admin/programs/{id}/trips
     * @secure
     */
    programsTripsDelete: (
      id: string,
      query: {
        /** Key of Segment to delete */
        adminManagedKey: string;
        mitIds?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/trips`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Add a list of trip legs for travelers
     *
     * @tags Admin
     * @name ProgramsTripsTravelersCreate
     * @request POST:/admin/programs/{id}/trips/travelers
     * @secure
     */
    programsTripsTravelersCreate: (
      id: string,
      data: AdminTrips,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/programs/${id}/trips/travelers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the count of trips and travelers
     *
     * @tags Admin Trips  Count
     * @name ProgramsStatsList
     * @request GET:/admin/programs/stats
     * @secure
     */
    programsStatsList: (
      query?: {
        searchText?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        departments?: string;
        cities?: string;
        countries?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProgramStats, any>({
        path: `/admin/programs/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Export the admin overview to excel
     *
     * @tags Admin Program Overview Export
     * @name ProgramsExportList
     * @request GET:/admin/programs/export
     * @secure
     */
    programsExportList: (
      query?: {
        sortField?: string;
        sortOrder?: string;
        searchText?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        departments?: string;
        cities?: string;
        countries?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExportItem, any>({
        path: `/admin/programs/export`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an overview for trips
     *
     * @tags Admin Trip Overview
     * @name TripsList
     * @request GET:/admin/trips
     * @secure
     */
    tripsList: (
      query?: {
        pageNumber?: string;
        pageSize?: string;
        sortField?: string;
        sortOrder?: string;
        searchText?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        tripTypes?: string;
        cities?: string;
        countries?: string;
        travelerMitId?: string;
        finalDestination?: boolean;
        affiliations?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTripsOverview, any>({
        path: `/admin/trips`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsCreate
     * @summary Add or update a trip
     * @request POST:/admin/trips
     * @secure
     */
    tripsCreate: (data: Trip, params: RequestParams = {}) =>
      this.request<Trip, any>({
        path: `/admin/trips`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsUpdate
     * @summary Update a trip
     * @request PUT:/admin/trips
     * @secure
     */
    tripsUpdate: (data: Trip, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/trips`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsDetail
     * @summary Get a trip
     * @request GET:/admin/trips/{id}
     * @secure
     */
    tripsDetail: (id: string, params: RequestParams = {}) =>
      this.request<Trip, any>({
        path: `/admin/trips/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name TripsDelete
     * @summary Cancel a trip
     * @request DELETE:/admin/trips/{id}
     * @secure
     */
    tripsDelete: (
      id: string,
      query: {
        /** MitId */
        mitId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/trips/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Export the admin overview to excel
     *
     * @tags Admin Trips Overview Export
     * @name TripsExportList
     * @request GET:/admin/trips/export
     * @secure
     */
    tripsExportList: (
      query?: {
        sortField?: string;
        sortOrder?: string;
        searchText?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        tripTypes?: string;
        cities?: string;
        countries?: string;
        travelerMitId?: string;
        finalDestination?: boolean;
        affiliations?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExportItem, any>({
        path: `/admin/trips/export`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the count of travelers for programs
     *
     * @tags Admin Program Travelers Stats
     * @name TripsStatsList
     * @request GET:/admin/trips/stats
     * @secure
     */
    tripsStatsList: (
      query?: {
        searchText?: string;
        tripTypes?: string;
        statuses?: string;
        dates?: string;
        highRisk?: boolean;
        departments?: string;
        cities?: string;
        countries?: string;
        finalDestination?: boolean;
        affiliations?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTripStats, any>({
        path: `/admin/trips/stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add traveler contact details to a trip.
     *
     * @tags User
     * @name ContactsCreate
     * @summary Add traveler contact details.
     * @request POST:/admin/contacts
     * @secure
     */
    contactsCreate: (
      data: TravelerContact | Contact,
      params: RequestParams = {},
    ) =>
      this.request<TravelerContact | Contact, any>({
        path: `/admin/contacts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update traveler contact details.
     *
     * @tags User
     * @name ContactsUpdate
     * @summary Update traveler contact details.
     * @request PUT:/admin/contacts
     * @secure
     */
    contactsUpdate: (
      data: TravelerContact | Contact,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/contacts`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  travelProfile = {
    /**
     * No description
     *
     * @tags User
     * @name TravelProfileDetail
     * @summary Get travel profile for a traveler
     * @request GET:/travel-profile/{mitId}
     * @secure
     */
    travelProfileDetail: (mitId: string, params: RequestParams = {}) =>
      this.request<TravelProfile, any>({
        path: `/travel-profile/${mitId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  apiHealth = {
    /**
     * @description Is the API reachable
     *
     * @name PingList
     * @request GET:/api-health/ping
     * @secure
     */
    pingList: (params: RequestParams = {}) =>
      this.request<ApiHealthPingResponse, any>({
        path: `/api-health/ping`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Can the API connect to all the various integrations that it should be able to
     *
     * @name StatusList
     * @request GET:/api-health/status
     * @secure
     */
    statusList: (params: RequestParams = {}) =>
      this.request<ApiStatusResponse, any>({
        path: `/api-health/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
